import React, { useReducer, createContext, useContext } from 'react';
import { PlayerUIReducer } from './reducer';
import { PlayerUIState } from './state';
const PlayerUIContext = createContext(null);
const PlayerUIContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(PlayerUIReducer, PlayerUIState);
    return (React.createElement(PlayerUIContext.Provider, { value: { state, dispatch } }, children));
};
PlayerUIContextProvider.displayName = 'PlayerUIContextProvider';
export const usePlayerUIContext = () => useContext(PlayerUIContext);
export * from './actions';
export { PlayerUIState, PlayerUIContextProvider, PlayerUIContext };
//# sourceMappingURL=index.js.map